import { apiPost } from './client';

export function calculate(inputs) {
  return apiPost('/api/v1/calculate', inputs);
}

export function trackEvent(eventType, payload = {}) {
  return apiPost('/api/v1/events', { event_type: eventType, payload });
}
